// /pages/carrossier/FormulaireB/hooks/useFormData.js
import { useState } from "react";

export const useFormData = () => {
  const [formData, setFormData] = useState({
    // Section Vérificateur
    verificateur: { Nom: "", Adresse: "", Contact: "", DateVerification: "" },
    
    // Section Client
    client: { Nom: "", Adresse: "", Contact: "" },
    
    // Section Véhicule
    vehicule: {
      Type: "",
      NumeroImmatriculation: "",
      MarqueCaisse: "",
      NumeroIdentificationCaisse: "",
    },
    
    // Section Porte
    porte: { NumeroSerie: "" },
    
    // Contrôles spécifiques Type B (HUSKY)
    controles: {
      tablier: {},
      rails: {},
      railsDetailles: {
        coteRailHorizontalChauffeur: "",
        coteRailHorizontalPassager: "",
      },
      ressorts: {},
      cadreArriere: {},
      cadreArriereDetaille: {
        parodiesLateralesBois: "",
        parodiesLateralesIsolees: "",
        pavillonTranslucide: "",
        pavillonIsole: ""
      },
      systemeCleverSafe: {},
      relevesEtMesures: {
        pressionCoffretCommande: "",
        tempsCycleMontee: "",
        tempsCycleDescente: "",
        fuitesVerin: "",
        tensionBatterie: ""
      },
    },
    
    // Déclaration finale
    declarationHonneur: false
  });

  const handleChange = (section, field, value) => {
    try {
      if (section === 'declarationHonneur') {
        setFormData(prev => ({ ...prev, declarationHonneur: value }));
        return;
      }

      setFormData((prev) => ({
        ...prev,
        [section]: { ...prev[section], [field]: value },
      }));
    } catch (error) {
      console.error("❌ Erreur dans handleChange:", error);
    }
  };

  const handleControleChange = (controle, field, value) => {
    try {
      setFormData((prev) => ({
        ...prev,
        controles: {
          ...prev.controles,
          [controle]: { ...prev.controles[controle], [field]: value },
        },
      }));
    } catch (error) {
      console.error("❌ Erreur dans handleControleChange:", error);
    }
  };

  return {
    formData,
    setFormData,
    handleChange,
    handleControleChange
  };
};